import { configureStore } from "@reduxjs/toolkit";
import { createLogger } from "redux-logger";
import { combineReducers } from "redux";

import adopt from "./adopt/reducer";
import auth from "./auth/reducer";
import generateForm from "./generate_form/reducer";
import helpStore from "./helpStore/reducer";
import invoice from "./invoice/reducer";
import kycRenewal from "./kyc-renewal/reducer";
import kyc from "./kyc/reducer";
import kycSession from "./kyc_session/reducer";
import myplans from "./myplans/reducer";
import { netPulseReducer as netPulse } from "@repo/redux/net-pulse";
import notificationStore from "./notification/reducer";
import paymentDetails from "./payment/reducer";
import profile_manager from "./profile_manager/reducer";
import team from "./profile_manager/team/reducer";
import quote from "./quote/reducer";
import tenants from "./tenants/reducer";
import tokenPlans from "./tokenPlans/reducer";
import users from "./users/reducer";
import validation from "./inlineValidation/reducer";
import workspan from "./workspan/reducer";
import opportunities from "./new-opportunity/reducer";
import { activeDealsReducer as activeDeals } from "@repo/redux";
import dealConfigs from "./deal-configs/reducer";
import manDays from "./man-days/reducer";
import dashboard from "./dashboard/reducer";
import csmFocus from "./csm-focus/reducer";
import psCalculator from "./ps-calculator";
import isight from "./isight/reducer";
import { siteInABoxReducer as siteInABox } from "./site-in-a-box";
import { loaReducer as loa } from "@repo/redux/loa";
import { createBrowserHistory } from "history";

export const history = createBrowserHistory();

// Combine reducers
const rootReducer = combineReducers({
  auth,
  users,
  tenants,
  adopt,
  dashboard,
  myplans,
  generateForm,
  profile_manager,
  team,
  helpStore,
  notificationStore,
  paymentDetails,
  invoice,
  tokenPlans,
  kycSession,
  kyc,
  kycRenewal,
  quote,
  netPulse,
  validation,
  workspan,
  opportunities,
  activeDeals,
  dealConfigs,
  manDays,
  csmFocus,
  psCalculator,
  isight,
  siteInABox,
  loa,
});

// Configure store
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      // Disable immutable check for performance optimization
      serializableCheck: false, // Disable serializable check for performance optimization
    }).concat(
      process.env.NODE_ENV === "development" ? createLogger() : [], // Enable logger in development mode
    ),
});

export default store;
